import { CreateValueAddedServiceInterface } from "../interfaces/ValueAddedServiceInterface/CreateValueAddedServiceInterface";
import { ValueAddedServiceInterface } from "../interfaces/ValueAddedServiceInterface/ValueAddedServiceInterface";
import BaseService from "./BaseService";

export class ValueAddedService extends BaseService<ValueAddedServiceInterface, CreateValueAddedServiceInterface>{ 
    constructor(){
        let url: string = '/value-added-service/admin'
        super(url)
    }
}